export const SET_USER_PROCESSING = 'SET_USER_PROCESSING'
export const GET_USERS_BY_QUERY = 'GET_USERS_BY_QUERY'
export const SET_USERS_BY_QUERY = 'SET_USERS_BY_QUERY'
export const SET_USERS_BY_QUERY_ERROR = 'SET_USERS_BY_QUERY_ERROR'

export function setUserProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function getUsersByQuery ({
  storeKey,
  uid,
  uuid,
  billingAccountId,
  billingAccountNumber,
  email,
  emailLike,
  firstName,
  lastName,
  name,
  username,
  usernameLike,
  invoiceNumber,
  paymentNumber,
  ccLast4,
  recurringPaymentId,
  yogaInternationalUserId,
  paidThroughDateStart,
  paidThroughDateEnd,
  page,
  perPage,
}) {
  return {
    type: GET_USERS_BY_QUERY,
    payload: {
      storeKey,
      uid,
      uuid,
      billingAccountId,
      billingAccountNumber,
      email,
      emailLike,
      firstName,
      lastName,
      name,
      username,
      usernameLike,
      invoiceNumber,
      paymentNumber,
      ccLast4,
      recurringPaymentId,
      yogaInternationalUserId,
      paidThroughDateStart,
      paidThroughDateEnd,
      page,
      perPage,
    },
  }
}

export function setUsersByQuery ({ storeKey, data }) {
  return {
    type: SET_USERS_BY_QUERY,
    payload: { storeKey, data },
  }
}

export function setUsersByQueryError ({ storeKey, error, keyword }) {
  return {
    type: SET_USERS_BY_QUERY_ERROR,
    payload: { storeKey, error, keyword },
  }
}
